import React, { Component } from 'react';
import { connect } from 'react-redux';
import TimeEntry from './TimeEntry/TimeEntry';
import * as Features from '../../../../../utils/Features';
import './Timeline.css';
import { TIMELINE } from '../../../../../content';
import * as Mover from '../../../../../utils/Mover';

class Timeline extends Component {
  constructor(props) {
    super(props);

    // ref
    this.timelineRef = React.createRef();

    // bind
    this.loop = this.loop.bind(this);
  }

  // -------------------------------------------------------
  // Lifecycle
  // -------------------------------------------------------

  componentDidMount() {
    this.startLoop();
  }

  componentWillUnmount() {
    this.stopLoop();
  }

  // -------------------------------------------------------
  // Loop
  // -------------------------------------------------------

  loop() {
    // note - maybe just show/hide (1/0) instead of kind of unnecesary opacity move
    this.timelineRef.current.style.opacity = Mover.getTimelineAlpha();
    this.loopRef = window.requestAnimationFrame(this.loop);
  }

  startLoop() {
    if (!this.loopRef) {
      this.loopRef = window.requestAnimationFrame(this.loop);
    }
  }

  stopLoop() {
    window.cancelAnimationFrame(this.loopRef);
  }

  // -------------------------------------------------------
  // Render
  // -------------------------------------------------------

  render() {
    const entries = TIMELINE.map((entry, index) => (
      <TimeEntry key={entry.pos} data={entry} position={index} />
    ));

    return (
      <div
        id="timeline"
        className={
          Features.features.mobile && this.props.sceneVideo.length > 0
            ? 'hidden'
            : ''
        }
        ref={this.timelineRef}
      >
        {entries}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  sceneVideo: state.app.sceneVideo,
});

export default connect(mapStateToProps)(Timeline);



// WEBPACK FOOTER //
// ./src/components/App/Dukla/Scene/Timeline/Timeline.js